module.exports = __webpack_public_path__ + "static/MattiasA-2e6f193345f4b8572355406c64f671c7.gif";